import "../sentryInstrumentReact";
import React, { useState } from 'react';

function AddressFormInput({ 
  type, 
  name, 
  label, 
  value, 
  onChange, 
  maxLength, 
  minLength,
  min,
  placeholder, 
  required=false, 
  className='form-control', 
  labelClassName = "text-label", 
  idPrefix = '',
  tooltipText,
  errors = [],
}) {
  const [isFocused, setIsFocused] = useState(false);
  const id = `${idPrefix}_${name}`;
  const isActive = isFocused || value !== '';

  let inputClasses = "form-group";
  if (errors.length >= 1) {
    inputClasses += " error";
  }
  
  return (
    <div className={inputClasses} id={`div_${id}`}>
      <label htmlFor={id} className={`${labelClassName} ${isActive ? 'active' : ''}`.trim()}>{label}
        {tooltipText && <span className="tooltip2">
          <svg className="icon"><use xlinkHref="#info-circle"/></svg>
          <span className="top">{tooltipText}
            <i></i>
          </span>
        </span>}
      </label>
      <input 
        type={type} 
        name={name}
        className={className} 
        maxLength={maxLength} 
        minLength={minLength}
        required={required} 
        id={id} 
        placeholder={placeholder} 
        value={value} 
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={onChange} 
        min={min}
      />
      {errors.length >= 1 && 
        <ul>
          {errors.map((error, index) => (
            <li key={index}>{error}</li>
          ))}
        </ul>
      }
    </div>
  );
}

export default AddressFormInput;
